import { JsonObject } from '../types';
import { BookingDate, Footer, Header, Tag20, Tag28, Tag61, Tag86, WithoutTransactions } from '../types/Settings';

export class Mt942Settings {
  public header: Header;
  public footer: Footer;
  public tag20: Tag20;
  public tag28: Tag28;
  public tag61: Tag61;
  public tag86: Tag86;
  public withoutTransactions: WithoutTransactions;
  public bookingDate: BookingDate;

  constructor(json?: JsonObject) {
    this.header = json?.header ? json.header : 'SETTINGS_DOWNLOAD_HEADER_OPTION_A';
    this.footer = json?.mt999Footer ? json.mt999Footer : 'SETTINGS_DOWNLOAD_MT999_FOOTER_OPTION_A';
    this.tag20 = json?.tag20 ? json.tag20 : 'SETTINGS_DOWNLOAD_TAG_20_OPTION_A';
    this.tag28 = json?.tag28 ? json.tag28 : 'SETTINGS_DOWNLOAD_TAG_28_OPTION_A';
    this.tag61 = json?.tag61 ? json.tag61 : 'SETTINGS_DOWNLOAD_TAG_61_OPTION_A';
    this.tag86 = json?.tag86 ? json.tag86 : 'SETTINGS_DOWNLOAD_TAG_86_OPTION_A';
    this.withoutTransactions = json?.withoutTransactions
      ? json.withoutTransactions
      : 'SETTINGS_DOWNLOAD_WITHOUT_TR_OPTION_A';
    this.bookingDate = json?.trBookingDate ? json.trBookingDate : 'SETTINGS_DOWNLOAD_TRANSACTION_BOOKING_DATE_OPTION_B';
  }
}
